module.exports = __webpack_public_path__ + "img/background.cb750ca7.png";